window.FlybyuCasePricing = (function(){
  // Auto-generated from the live Shopify "Case Pricing" automatic discounts
  // (created 2026-09-12; variant list updated 2026-09-14 to add the missing
  // Motul 20W-50/1L and 15W-50/4L variants plus 2-stroke oil coverage across
  // all 5 brands — see the collaboration-plan.md writeup for the full story).
  // If those discounts ever change — tiers, percentages, or which variants
  // they cover — this file must be regenerated to match, or the preview
  // shown to customers will drift from what checkout actually gives them.
  //
  // 2026-09-18: added the Motorex Racing Gear Oil 10W40 variant below as a
  // SANDBOX-ONLY preview test for Derek, on his pilot bike-fit product page
  // template. This is a client-side preview mirror only — it does NOT
  // create or change any real Shopify discount, so this variant does not
  // actually receive a discount at real checkout yet. See collaboration-
  // plan.md for the open question on whether to extend the real, live
  // per-brand automatic discount (currently engine-oils-only by design) to
  // gear oil so the two match.
  var TIERS = [
    { qty: 12, pct: 0.15 },
    { qty: 6, pct: 0.10 },
    { qty: 3, pct: 0.05 }
  ];
  var ELIGIBLE_VARIANTS = {
    "45788051275931": "motul",
    "45788051341467": "motul",
    "45788051439771": "motul",
    "45788051505307": "motul",
    "45788051570843": "motul",
    "45962722738331": "motul",
    "48145003970715": "motul",
    "45791782961307": "motul",
    "45791783026843": "motul",
    "45791783125147": "motul",
    "45791783223451": "motul",
    "45962872750235": "motul",
    "45962819633307": "motul",
    "45960238235803": "motul",
    "45839246196891": "motul",
    "45836722372763": "motul",
    "45836722471067": "motul",
    "45792883507355": "motul",
    "45792883572891": "motul",
    "45792883638427": "motul",
    "45792883736731": "motul",
    "45792883802267": "motul",
    "45788051636379": "motul",
    "45788051603611": "motul",
    "45960262385819": "motul",
    "45963252531355": "motul",
    "45963299291291": "motul",
    "45963484102811": "motul",
    "45966350647451": "motul",
    "45966381744283": "motul",
    "48214615261339": "motorex",
    "48214292365467": "motorex",
    "48214292398235": "motorex",
    "48214003155099": "motorex",
    "48213833056411": "motorex",
    "48207577907355": "motorex",
    "48207577940123": "motorex",
    "48207577972891": "motorex",
    "48207578005659": "motorex",
    "48202922295451": "motorex",
    "48202922328219": "motorex",
    "48202922360987": "motorex",
    "48202846994587": "motorex",
    "48202847027355": "motorex",
    "48202847060123": "motorex",
    "48202673258651": "motorex",
    "48202673291419": "motorex",
    "48202673324187": "motorex",
    "48214501163163": "motorex",
    "48153550258331": "klotz",
    "48153550291099": "klotz",
    "48153550323867": "klotz",
    "48141193281691": "klotz",
    "48141193314459": "klotz",
    "48141193347227": "klotz",
    "48141189611675": "klotz",
    "48141189644443": "klotz",
    "48141189677211": "klotz",
    "48141189709979": "klotz",
    "48141179093147": "klotz",
    "48141179125915": "klotz",
    "48141179158683": "klotz",
    "48141171982491": "klotz",
    "48141172015259": "klotz",
    "48141170999451": "klotz",
    "48141163823259": "klotz",
    "48141163856027": "klotz",
    "48141163888795": "klotz",
    "48141163921563": "klotz",
    "48141161726107": "klotz",
    "48153107366043": "klotz",
    "48153282314395": "klotz",
    "48153416794267": "klotz",
    "48153473581211": "klotz",
    "48153505398939": "klotz",
    "48028969042075": "maxima",
    "48028969107611": "maxima",
    "48028969173147": "maxima",
    "48028969238683": "maxima",
    "48028959441051": "maxima",
    "48028956786843": "maxima",
    "48028888531099": "maxima",
    "48028888563867": "maxima",
    "48028888596635": "maxima",
    "48028806512795": "maxima",
    "48028806545563": "maxima",
    "48028806578331": "maxima",
    "48028806611099": "maxima",
    "48028773253275": "maxima",
    "48028773286043": "maxima",
    "48028773318811": "maxima",
    "48028773351579": "maxima",
    "48028747006107": "maxima",
    "48028742385819": "maxima",
    "48028635791515": "maxima",
    "45990749012123": "maxima",
    "45990749044891": "maxima",
    "45990749110427": "maxima",
    "48040123957403": "maxima",
    "48040123990171": "maxima",
    "45989687951515": "maxima",
    "45989679235227": "maxima",
    "45989679267995": "maxima",
    "45989679300763": "maxima",
    "45989679333531": "maxima",
    "48028990374043": "maxima",
    "48028998697115": "maxima",
    "48029005119643": "maxima",
    "48040211939483": "maxima",
    "45987533652123": "liqui-moly",
    "45987532275867": "liqui-moly",
    "45987498492059": "liqui-moly",
    "45987492561051": "liqui-moly",
    "45987487023259": "liqui-moly",
    "45986154872987": "liqui-moly",
    "45984508477595": "liqui-moly",
    "45984407060635": "liqui-moly",
    "45984286507163": "liqui-moly",
    "45984268648603": "liqui-moly",
    "45981678534811": "liqui-moly",
    "45981609689243": "liqui-moly",
    "45981488611483": "liqui-moly",
    "45981268410523": "liqui-moly",
    "45987569238171": "liqui-moly",
    "45987577561243": "liqui-moly",
    "48223053250715": "motorex"
};

  function getTier(qty){
    for (var i = 0; i < TIERS.length; i++){
      if (qty >= TIERS[i].qty) return TIERS[i];
    }
    return null;
  }

  function nextTier(qty){
    // Returns the next tier up (to power a "add N more to save X%" nudge), or null if already at the top.
    var ascending = TIERS.slice().sort(function(a,b){ return a.qty - b.qty; });
    for (var i = 0; i < ascending.length; i++){
      if (qty < ascending[i].qty) return ascending[i];
    }
    return null;
  }

  function isEligible(variantId){
    return Object.prototype.hasOwnProperty.call(ELIGIBLE_VARIANTS, String(variantId));
  }

  function brandFor(variantId){
    return ELIGIBLE_VARIANTS[String(variantId)] || null;
  }

  return {
    tiers: TIERS,
    getTier: getTier,
    nextTier: nextTier,
    isEligible: isEligible,
    brandFor: brandFor
  };
})();
